import { Box, InputLabel, TextField, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React from "react";
import { useCommonStyles } from "../../utils";
import { DesktopDatePicker, MobileDatePicker } from "@mui/x-date-pickers";

const CommonDatePicker = ({
  size,
  placeholder,
  name,
  value,
  label,
  onChange,
  format,
  maxDate,
  minDate,
  fontWeight,
  fontSize,
  fontFamily,
  color,
  marginBottom,
  disabled,
  valid,
  width,
  sx,
  labelColor
}) => {
  const { classes } = useCommonStyles();
  return (
    <div>
      {label && (
        <Box display={"flex"} gap={'2px'}>
          <InputLabel
            className={classes.label}
            sx={{
              fontWeight: fontWeight ? fontWeight : "500",
              fontSize: fontSize ? fontSize : "14px",
              fontFamily: "Satoshi-Medium",
              color: labelColor || "#2E2E30",
              marginBottom: marginBottom || "8px",
              textTransform: "capitalize",
            }}
          >
            {label}
          </InputLabel>
          {valid && (
            <Typography height={'5px'} color="#EF627A" component={"caption"} variant={"body2"}>
              *
            </Typography>
          )}
        </Box>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {/* <MobileDatePicker
          className={classes.field}
          disabled={disabled}
          name={name}

          value={value}
          onChange={onChange}
          renderInput={(params) => <TextField size={size} {...params}
            sx={{
              ...sx,
              "& .MuiOutlinedInput-root": {
                width: width ? width : "100%",
              },
            }} placeholder={value ? "" : placeholder || "DD/MM/YYYY"} />}
          inputFormat={"DD/MM/YYYY"}
          placeholder={"dd"}
          maxDate={maxDate}
          minDate={minDate}
        /> */}
        <DesktopDatePicker
          disabled={disabled}
          name={name}
          value={value}
          onChange={onChange}
          renderInput={(params) => <TextField size={size} {...params}
            sx={{
              ...sx,
              width: width ? width : "100%",
              "& .MuiOutlinedInput-root": {
                backgroundColor: "#FFF",
              }
            }} placeholder={value ? "" : placeholder || "DD/MM/YYYY"} />}
          inputFormat={"DD/MM/YYYY"}
          placeholder={"dd"}
          maxDate={maxDate}
          minDate={minDate}
        />
      </LocalizationProvider>
    </div>
  );
};

export default CommonDatePicker;
